import api from './api';

export const roleService = {
  getAll: async () => {
    const response = await api.get('/roles');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/roles/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/roles', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/roles/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
  },

  addPermission: async (roleId, permissionId) => {
    const response = await api.post(`/roles/${roleId}/permissions`, { permissionId });
    return response.data;
  },

  removePermission: async (roleId, permissionId) => {
    const response = await api.delete(`/roles/${roleId}/permissions/${permissionId}`);
    return response.data;
  },

  getUsers: async (roleId) => {
    const response = await api.get(`/roles/${roleId}/users`);
    return response.data;
  },

  invalidateCache: async () => {
    const response = await api.post('/roles/invalidate-cache');
    return response.data;
  },
};

export default roleService;
